export var transformDataToOption = function transformDataToOption(listData) {
  return listData.map(function (data) {
    return {
      label: data,
      value: data
    };
  });
};